@if (title) {
    <p class="uilab-mat-label-large">{{ title }}</p>
}
<div class="css-variable-snippet__code-block">
    <pre>
		  <code [highlight]="snippet" [language]="language"></code>
      <button
        uilabMatIconButton
        class="css-variable-snippet__copy-button uilab-mat-icon-button-density--2"
        aria-label="Copy code snippet"
        title="Copy code snippet"
        (click)="copySnippet()"
      >
          <uilab-mat-icon svgIcon="action--copy_outlined"></uilab-mat-icon>
      </button>
	  </pre>
</div>
